module.exports = __webpack_public_path__ + "img/report5.48e743c4.svg";